module.exports = __webpack_public_path__ + "img/trees.c9055f90.svg";